import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import StockItemsLayer from "../components/StockItemsLayer";

const StockItemsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Stock Items'>

        {/* StockItemsLayer */}
        <StockItemsLayer />
      </MasterLayout>
    </>
  );
};

export default StockItemsPage;
